import CommunicatorDialog from './CommunicatorDialog.container';

export default CommunicatorDialog;
